import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "./registerServiceWorker";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Button from "./components/Button";
import Hilight from "./components/Highlight";

import SectionHeader from "./components/SectionHeader";
import Focus from "./components/Focus";
import Why from "./components/Why";
import Logo from "../public/img/logo.svg";
import WhyImage from "./components/WhyImage";
import Services from "./components/Services";
import ServiceCard from "./components/ServiceCard";
import Card from "./components/Card";
import Text from "./components/Text";
import TestimonialCard from "./components/TestimonialCard";
import Testimonials from "./components/Testimonials";
import TechStack from "./components/TechStack";

import WhyBackgroundImage from "./components/WhyBackgroundImage";
import ServicesBackgroundShape from "../public/img/services-background-shape.svg";

import HeroSVG from "../public/img/hero.svg";
import ProductDesignSVG from "../public/img/product-design-icon.svg";
import ProductEngineeringSVG from "../public/img/product-engineering-icon.svg";
import ProductDeploymentSVG from "../public/img/product-deployment-icon.svg";

import FrontEndDevelopmentIcon from "../public/img/front-end-development-icon.svg";
import BackEndDevelopmentIcon from "../public/img/back-end-development-icon.svg";
import UXUIDesignIcon from "../public/img/ux-ui-design-icon.svg";
import TestingAndQAIcon from "../public/img/testing-and-qa-icon.svg";
import FullDeploymentIcon from "../public/img/full-deployment-icon.svg";
import ConsultingIcon from "../public/img/consulting-icon.svg";
import IrishFlagIcon from "../public/img/irish-flag-icon.svg";
import HamburgerIcon from "../public/img/hamburger.svg";

Vue.config.productionTip = false;

Vue.component("app-header", Header);
Vue.component("app-footer", Footer);
Vue.component("app-hero", Hero);
Vue.component("app-hero-image", HeroSVG);
Vue.component("app-button", Button);
Vue.component("app-hilight", Hilight);
Vue.component("app-section-header", SectionHeader);
Vue.component("app-focus", Focus);
Vue.component("app-why", Why);
Vue.component("app-why-background-image", WhyBackgroundImage);
Vue.component("app-logo", Logo);
Vue.component("app-why-image", WhyImage);
Vue.component("app-product-design-image", ProductDesignSVG);
Vue.component("app-product-engineering-image", ProductEngineeringSVG);
Vue.component("app-product-deployment-image", ProductDeploymentSVG);
Vue.component("app-services", Services);
Vue.component("app-service-card", ServiceCard);
Vue.component("app-front-end-development-image", FrontEndDevelopmentIcon);
Vue.component("app-back-end-development-image", BackEndDevelopmentIcon);
Vue.component("app-ux-ui-design-image", UXUIDesignIcon);
Vue.component("app-testing-and-qa-image", TestingAndQAIcon);
Vue.component("app-full-deployment-image", FullDeploymentIcon);
Vue.component("app-consulting-image", ConsultingIcon);
Vue.component("app-irish-flag-icon", IrishFlagIcon);
Vue.component("app-hamburger-icon", HamburgerIcon);
Vue.component("app-card", Card);
Vue.component("app-text", Text);
Vue.component("app-testimonials", Testimonials);
Vue.component("app-testimonial-card", TestimonialCard);
Vue.component("app-tech-stack", TechStack);
Vue.component("app-services-background-shape", ServicesBackgroundShape);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
